import { buttonReset } from 'style/styled-components/cssButtonReset';
import { styled } from '../ThemeConfigConnector/ThemeConfigConnnector';
import { fontExtraBold } from '../../style/styled-components/cssGlobalVariables';
import { Breakpoints, MQ } from '../../style/styled-components/cssMediaQueries';

export const MessageContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    max-width: 500px;
    height: 100%;
    margin: 0 auto;
`;

export const ChannelLogo = styled.img`
    width: 142px;
    height: auto;
    margin-bottom: 24px;
`;

export const ChannelTitle = styled.h2`
    font-size: 32px;
    font-family: ${fontExtraBold};
    line-height: 1.3;
    color: var(--color-primary);
    margin: 0 0 16px 0;
`;

export const MessageText = styled.p`
    font-size: 16px;
    line-height: 1.5;
    color: var(--color-dark-body-70);
    margin: 0 16px 24px 16px;
    max-width: 480px;
`;

export const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
`;

const NavigationIcon = styled.button`
    ${buttonReset}
    cursor: pointer;

    &:hover {
        background: var(--color-dark-foreground-15);

        svg {
            color: var(--color-main-white);
        }
    }

    &:focus-visible {
        outline: var(--focus-outline);
    }
`;

export const BackButton = styled(NavigationIcon)`
    position: absolute;
    left: 16px;
    top: 6px;
    background: var(--color-dark-foreground-5);
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${MQ(Breakpoints.s)} {
        top: 16px;
        left: 26px;
    }

    ${MQ(Breakpoints.m)} {
        left: 46px;
    }

    svg {
        width: 18px;
        height: 18px;
        margin-top: 2px;
        margin-left: -2px;
    }
`;
